import { flagIsOn, observatoryFlags } from "@softmax/web-features/flags";

export function seedsAllowed({
  nodeEnv,
  flagsOn,
}: {
  readonly nodeEnv: string | undefined;
  readonly flagsOn: string | undefined;
}): boolean {
  if (nodeEnv !== "production") return true;

  const forced = new Set(
    (flagsOn ?? "")
      .split(",")
      .map((key) => key.trim())
      .filter(Boolean),
  );
  return flagIsOn({
    flags: undefined,
    key: observatoryFlags.previewStartTeam,
    forced,
  });
}
